import './index.css';

const LeftBarComponent = () => {
    return (
        <div className='leftbar-container'>
            <div id='leftbar-flex-container'>
                <a href="https://discord.gg/zCB4CQex5R" target="_blank" rel="noopener noreferrer" title='Ameria Discord' className='leftbar-link'>
                    <i className="fa-brands fa-discord leftbar-icon"/>
                </a>

                <a href="https://www.facebook.com/profile.php?id=61568328476628" target="_blank" rel="noopener noreferrer" title='Ameria Facebook' className='leftbar-link'>
                    <i className="fa-brands fa-facebook leftbar-icon"/>
                </a>

                <a href="https://otservlist.org" target="_blank" rel="noopener noreferrer" title='Ameria Otservlist' className='leftbar-link'>
                    <i className="fa-solid fa-server leftbar-icon2"/>
                </a>
            </div>
        </div>
    );
};

export default LeftBarComponent;